import { LocalStorageProgressRepository } from './LocalStorageProgressRepository';
import { MemoryProgressRepository } from './MemoryProgressRepository';
import type { ProgressRepository } from './repository';

export function createProgressRepository(): ProgressRepository {
  try {
    const key = '__skr_storage_probe__';
    localStorage.setItem(key, '1');
    localStorage.removeItem(key);
    return new LocalStorageProgressRepository();
  } catch {
    return new MemoryProgressRepository();
  }
}
